import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";

export interface EmploymentCategory {
  id: number;
  name: string;
}

export const getEmploymentCategories = async ({
  page = 1,
  limit = 20,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const response = await axiosClient.get<
    ApiResponse<ApiList<EmploymentCategory[]>>
  >("/employment-categories", {
    params: { page, limit, search: search || undefined },
  });
  return response.data;
};

export const getEmploymentCategoryOptions = async ({
  query,
  page = 1,
  limit = 20,
}: {
  query?: string;
  page?: number;
  limit?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      "/employment-categories/options",
      {
        params: {
          query: query?.trim() || undefined,
          page,
          limit,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching employment category options:", err);
    throw err;
  }
};

export const createEmploymentCategory = async (payload: { name: string }) => {
  const response = await axiosClient.post<
    ApiResponse<EmploymentCategory>
  >("/employment-categories", payload);
  return response.data;
};

export const updateEmploymentCategory = async (
  id: number,
  payload: { name: string },
) => {
  const response = await axiosClient.put<ApiResponse<EmploymentCategory>>(
    `/employment-categories/${id}`,
    payload,
  );
  return response.data;
};

export const deleteEmploymentCategory = async (id: number) => {
  const response = await axiosClient.delete<ApiResponse<unknown>>(
    `/employment-categories/${id}`,
  );
  return response.data;
};
